import { type ObjectValuesUnionType } from '../../../utils/typing';

import { type MPFamilyId } from './families';

export const MPCardTypes = Object.freeze({
  COLOR: 'COLOR',
  STATION: 'STATION',
  WATER: 'WATER',
  ELECTRICITY: 'ELECTRICITY',
});

export type MPCardType = ObjectValuesUnionType<typeof MPCardTypes>;

export const MPCardStatuses = Object.freeze({
  OPEN: 'OPEN',
  PENDING: 'PENDING',
  WON: 'WON',
});

export type MPCardStatus = ObjectValuesUnionType<typeof MPCardStatuses>;

export type MPCardProps = {
  familyId: MPFamilyId;
  index: number;
};
